import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bashboard_send_msg",
  "use": "icon-bashboard_send_msg-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 36 36\" id=\"icon-bashboard_send_msg\">\n<path d=\"M34.1,3.3L1.5,15.9c-1.8,0.7-1.8,1.7,0.1,2.3l7.9,2.3l3.2,9.5c0.4,1.2,1.5,1.5,2.4,0.6l4.1-4.1l8.1,6\n\tc1.1,0.8,2.1,0.4,2.4-0.9l5.9-26.7C36,3.5,35.3,2.8,34.1,3.3z M29.1,9.4L15.2,21.7c-0.2,0.2-0.5,0.7-0.5,1l-0.6,5.8\n\tc-0.1,0.6-0.3,0.7-0.5,0.1l-2.7-8.1c-0.1-0.3,0-0.7,0.3-0.9L28.8,9C30,8.3,30.1,8.5,29.1,9.4z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol